export enum TypeOfSaleEnum {
  INLAND = 'inland',
  IN_EUROPE = 'inEurope',
  OUT_OF_EUROPE = 'outOfEurope',
}
